export default {
  // API: 'http://localhost:10033',
  API: 'https://weipaiwap-api.tdbaike.cn', //后台API
  domain: 'https://weipaiwap.tdbaike.cn',
  ADMIN: 'http://weipai-api.tdbaike.cn',
  AppID: 'wx0e3e61b22d01f430'
}